import { endOfDay, isWithinInterval, startOfDay } from 'date-fns';
import _get from 'lodash/get';

export const isWithinPromotionDate = (parentList, now, list) => {
  if (
    !_get(list, 'fields.promotionDate') ||
    !_get(list, 'fields.promotionEndDate') ||
    !_get(parentList, 'fields.promotionDate')
  ) {
    return true;
  }

  const listEndDate = endOfDay(new Date(_get(list, 'fields.promotionEndDate')));
  const parentListStartDate = startOfDay(
    new Date(_get(parentList, 'fields.promotionDate')),
  );

  if (listEndDate <= parentListStartDate) {
    return true;
  }

  return isWithinInterval(now, {
    start: startOfDay(new Date(_get(list, 'fields.promotionDate'))),
    end: listEndDate,
  });
};
